export default "__VITE_ASSET__LU4S3WHI__"